import {combineReducers} from 'redux';
import showLeftMenu from './showLeftMenu';
import activeAccount from './activeAccount';
import darkMode from './darkMode';
import isConsideredMobile from './isConsideredMobile';
import isConsideredMedium from './isConsideredMedium';
import activeNetwork from './activeNetwork';
import cryptoEscrowFlow from './cryptoEscrowFlow';
import btcPrice from './btcPrice';
import coinbaseEscrowSlideshowIndex from './coinbaseEscrowSlideshowIndex';
import coinbaseEscrowShowListingZone from './coinbaseEscrowShowListingZone';
import coinbaseEscrowFlowVersion from './coinbaseEscrowFlowVersion';
import lastAttemptedXShareListingId from './lastAttemptedXShareListingId';

const rootReducer = combineReducers({
    showLeftMenu,
    activeAccount,
    darkMode,
    isConsideredMobile,
    isConsideredMedium,
    activeNetwork,
    cryptoEscrowFlow,
    btcPrice,
    coinbaseEscrowSlideshowIndex,
    coinbaseEscrowShowListingZone,
    coinbaseEscrowFlowVersion,
    lastAttemptedXShareListingId,
});

export default rootReducer;